<template>
  <div>
    <el-form inline :model="criteria" size="small">
      <el-form-item label="采购客户：">
        <el-input v-model.trim="criteria.buyerOrgName" placeholder="请输入采购客户名称"></el-input>
      </el-form-item>
      <el-form-item label="订单编号：">
        <el-input v-model.trim="criteria.bizOrderId" placeholder="请输入订单编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="startSearch">确定</el-button>
        <el-button @click="reset">清除</el-button>
      </el-form-item>
    </el-form>
    <el-tabs :value="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="全部" name="all"></el-tab-pane>
      <el-tab-pane label="待补退" name="wait"></el-tab-pane>
      <el-tab-pane label="已补退" name="finished"></el-tab-pane>
    </el-tabs>
    <el-table :data="tableData">
      <el-table-column prop="bizOrderId" label="订单号"></el-table-column>
      <el-table-column prop="buyerOrgName" label="采购客户"></el-table-column>
      <el-table-column label="订单状态">
        <template v-slot="scope">
          <span>{{ scope.row.orderStatus | orderStatusFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单实际已收款">
        <template v-slot="scope">
          <span>{{ scope.row.paidAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="订单已结算金额">
        <template v-slot="scope">
          <span>{{ scope.row.settledAmount | currencyFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column label="补退金额">
        <template v-slot="scope">
          <span v-if="scope.row.amount === 0 || scope.row.allowPayStatus === 2">--</span>
          <span v-else>
            {{ scope.row.amountDirection === 1 ? '待补款' : '待退款' }}
            <span class="c-hover">{{ Math.abs(scope.row.amount) | currencyFormat }}</span>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template v-slot="scope">
          <div>
            <el-button type="text" @click="showWaitDetail(scope)">查看详情</el-button>
          </div>
          <div v-if="showOperateButton(scope)">
            <el-button type="text" @click="handleOperateClick(scope)">{{
              scope | convertOperateText
            }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin:20px;text-align:right;"
      v-show="total > 0"
      @size-change="handleSizeChange"
      @current-change="paging"
      :current-page="criteria.pageNo"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="criteria.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <refund-dialog
      :visible.sync="refundVisible"
      :data="refundData"
      @refresh="fetch"
    ></refund-dialog>
    <supplement-dialog
      :visible.sync="supplementVisible"
      :data="supplementData"
      @refresh="fetch"
    ></supplement-dialog>
  </div>
</template>

<script>
import { validNumber } from '@/common/utils/validate.js'
import RefundDialog from './component/refund-dialog'
import SupplementDialog from './component/supplement-dialog'

const defaultCriteria = {
  pageNo: 1,
  pageSize: 10,
  buyerOrgName: '',
  bizOrderId: ''
}

const text_supplement = '确认收到补款'
const text_refund = '去退款'
const text_see_refund = '查看退款凭证'

export default {
  name: 'SettlementWaitList',
  components: { RefundDialog, SupplementDialog },
  data() {
    return {
      activeName: 'all',
      allowPayStatus: '0',
      criteria: { ...defaultCriteria },
      tableData: [],
      total: 0,

      refundVisible: false,
      refundData: {
        bizOrderId: '',
        accountPayId: '',
        buyerOrgName: '',
        buyerOrgId: '',
        amount: '',
        isPreview: false
      },

      supplementVisible: false,
      supplementData: {
        bizOrderId: '',
        accountPayId: '',
        buyerOrgName: ''
      }

      // loopSettleOrderId : null,
      // loopCount : 0,
    }
  },
  filters: {
    convertOperateText(scope) {
      const {
        amount,
        allowPayStatus,
        accountPayStatus,
        certUploadFlag,
        amountDirection
      } = scope.row
      if (amount !== 0 && allowPayStatus === 1) {
        //金额不等于0并且允许支付
        if (accountPayStatus == 3) {
          //支付中
          if (certUploadFlag) {
            //线下支付，已经上传凭证
            if (amountDirection === 1) {
              //确认收到补款
              return text_supplement
            } else {
              //查看凭证
              return text_see_refund
            }
          }
        } else {
          //非支付中
          if (amountDirection === 2) {
            //去退款
            return text_refund
          }
        }
      }
      return ''
    }
  },
  created() {
    this.fetch()
  },
  activated() {
    this.fetch()
  },
  methods: {
    showOperateButton(scope) {
      const {
        amount,
        allowPayStatus,
        accountPayStatus,
        certUploadFlag,
        amountDirection
      } = scope.row
      if (amount !== 0 && allowPayStatus === 1) {
        //金额不等于0并且允许支付
        if (accountPayStatus === 3 && certUploadFlag) {
          //支付中
          return true
        } else {
          //非支付中
          if (amountDirection === 2) {
            //去退款
            return true
          }
        }
      }
      return false
    },
    showWaitDetail(scope) {
      this.$router.push({ name: 'SettlementWaitDetail', params: { id: scope.row.bizOrderId } })
    },
    handleTabClick(tab) {
      if (tab.name === this.activeName) return
      this.activeName = tab.name
      this.criteria.pageNo = 1
      if (tab.name === 'all') {
        this.allowPayStatus = '0'
      } else if (tab.name === 'wait') {
        this.allowPayStatus = '1'
      } else {
        this.allowPayStatus = '3'
      }
      this.fetch()
    },
    startSearch() {
      this.criteria.pageNo = 1
      if (validNumber(this.criteria.bizOrderId)) {
        this.fetch()
      } else {
        this.$message.warning('请输入正确的订单号!')
        return false
      }
    },
    reset() {
      this.criteria = { ...defaultCriteria }
      this.fetch()
    },
    paging(page) {
      this.criteria.pageNo = page
      this.fetch()
    },
    handleSizeChange(val) {
      this.criteria.pageSize = val
      this.fetch()
    },
    async fetch() {
      const request = { allowPayStatus: this.allowPayStatus }

      Object.keys(this.criteria).forEach(key => {
        if (!this.criteria[key]) {
          return
        }
        if (key === 'dateRang') {
          if (this.criteria[key].length === 2) {
            request.settleOrderCreatedBegin = this.criteria[key][0]
            request.settleOrderCreatedEnd = this.criteria[key][1]
          }
        } else {
          request[key] = this.criteria[key]
        }
      })
      const { success, data } = await this.$post('accountOrder.seller.queryAccountOrders', {
        request
      })
      if (success && data) {
        const { totalNum, accountOrderVOList } = data[0]
        this.total = totalNum
        this.tableData = accountOrderVOList
        // if (this.loopSettleOrderId) {
        //     this.checkUpload();
        // }
      }
    },
    handleOperateClick(scope) {
      const text = this.$options.filters.convertOperateText(scope)
      if (text === text_supplement) {
        //确认补款
        this.supplementData.bizOrderId = scope.row.bizOrderId
        this.supplementData.accountPayId = scope.row.accountPayId
        this.supplementData.buyerOrgName = scope.row.buyerOrgName
        this.supplementVisible = true
      } else {
        this.refundData.bizOrderId = scope.row.bizOrderId
        this.refundData.accountPayId = scope.row.accountPayId
        this.refundData.buyerOrgName = scope.row.buyerOrgName
        this.refundData.buyerOrgId = scope.row.buyerOrgId
        this.refundData.amount = scope.row.amount
        this.refundData.isPreview = text === text_refund ? false : true
        this.refundVisible = true
      }
    }
    // loopRefresh(settleOrderId) {
    //     this.loopSettleOrderId = settleOrderId;
    //     setTimeout(() => {
    //         this.fetch();
    //     }, 300);
    // },
    // checkUpload() {
    //     const order = this.datas.find(
    //         ele => ele.settleOrderId === this.loopSettleOrderId
    //     );
    //     if (order) {
    //         if (order.status === 2) {
    //             if (this.loopCount < 3) {
    //                 this.loopCount = this.loopCount + 1;
    //                 setTimeout(() => {
    //                 this.startSearch();
    //                 }, 500);
    //             } else {
    //                 this.loopSettleOrderId = null;
    //                 this.loopCount = 0;
    //             }
    //         } else {
    //         this.loopSettleOrderId = null;
    //         this.loopCount = 0;
    //         }
    //     } else {
    //         this.loopSettleOrderId = null;
    //         this.loopCount = 0;
    //     }
    // }
  }
}
</script>
